import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { AdvancedListRequest } from "types/api/commons";

import { TemplateBody, TemplateDetails, TemplateListItem } from "types/api/template";

function useTemplateApi() {
    const { get, del, post, put } = useHttpManaged();
    const getAllTemplate = React.useCallback((queryParams: AdvancedListRequest, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ListResponse<TemplateListItem>> => {
        return get<undefined, AdvancedListRequest, ListResponse<TemplateListItem>>({
            url: "/template",
            queryParams: queryParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const getOneTemplate = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<TemplateDetails> => {
        return get<PathParamsWithId, undefined, TemplateDetails>({
            url: "/template/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const createTemplate = React.useCallback((body: TemplateBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, TemplateBody, ResponseWithId>({
            url: "/template",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateTemplate = React.useCallback((pathParams: PathParamsWithId, body: TemplateBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, TemplateBody, null>({
            url: "/template/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteTemplate = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/template/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getAllTemplate,
        getOneTemplate,
        createTemplate,
        updateTemplate,
        deleteTemplate
    };
}

export default useTemplateApi;